import React from 'react';
import { Grid } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { AppState } from 'services/types';

import {
    FertilizerProductId,
    FertilizerEntityIds,
    FertilizerEventProduct,
    FertilizerProductOrderIndex,
    FertilizerProductPerUnitType,
    FertilizerProductUnits
} from 'services/fertilizerEvents/types';

import { makeSelectFertilizerProductValue } from 'services/fertilizerProducts/selectors';
import FertilizerEventOrderIntoTankListItem from '../../../../../FertilizerEventProductListItems/components/FertilizerEventOrderIntoTankListItem';
import FertilizerEventReEntryPeriodListItem from '../../../../../FertilizerEventProductListItems/components/FertilizerEventReEntryPeriodListItem';
import FertilizerEventWithholdingPeriodListItem from '../../../../../FertilizerEventProductListItems/components/FertilizerEventWithholdingPeriodListItem';
import FertilizerEventProductTotalListItem from '../../../../../FertilizerEventProductListItems/components/FertilizerEventProductTotalListItem';
import FertilizerEventRateListItem from '../../../../../FertilizerEventProductListItems/components/FertilizerEventRateListItem';
import FertilizerEventNameListItem from '../../../../../FertilizerEventProductListItems/components/FertilizerEventNameListItem';

export interface OwnProps {
    productId: FertilizerProductId;
    orderIntoTank: FertilizerProductOrderIndex;
    product: FertilizerEventProduct;
    entityIds: FertilizerEntityIds;
    units: FertilizerProductUnits;
    perUnitType: FertilizerProductPerUnitType;
}

type Props = OwnProps;

export default function FertilizerEventSummaryProductsList(
    props: Props
): React.ReactElement {
    const { productId, orderIntoTank, entityIds, product, units, perUnitType } =
        props;

    const unitTypeId = useSelector((state: AppState) =>
        makeSelectFertilizerProductValue('unitTypeId')(state, props)
    );

    return (
        <Grid className="summary-list-item">
            <Grid.Row>
                <Grid.Column className="summary-list-item-title">
                    Fertilizer product #{orderIntoTank}
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column mobile={8} tablet={4} computer={4}>
                    <FertilizerEventNameListItem productId={productId} />
                </Grid.Column>
                <Grid.Column mobile={8} tablet={4} computer={4}>
                    <FertilizerEventOrderIntoTankListItem
                        orderIntoTank={orderIntoTank}
                    />
                </Grid.Column>
                <Grid.Column mobile={8} tablet={4} computer={4}>
                    <FertilizerEventReEntryPeriodListItem
                        productId={productId}
                    />
                </Grid.Column>
                <Grid.Column mobile={8} tablet={4} computer={4}>
                    <FertilizerEventWithholdingPeriodListItem
                        productId={productId}
                    />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column mobile={8} tablet={4} computer={4}>
                    <FertilizerEventProductTotalListItem
                        unitTypeId={unitTypeId}
                        product={product}
                        productId={productId}
                        entityIds={entityIds}
                        perUnitType={perUnitType}
                    />
                </Grid.Column>
                <Grid.Column mobile={8} tablet={4} computer={4}>
                    <FertilizerEventRateListItem
                        unitTypeId={unitTypeId}
                        units={units}
                        perUnitType={perUnitType}
                    />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}
